<template>
    <div class="home-page cg-page">
    <div class="pt20">
    <a class="logo" href="/"><img src="static/images/logo-new.png" /></a>
    </div>
		<div class="content">
      <div class="drop-down-content">
        <div class="login-content">
          <div class="ac fs33 pt20" style="width:80%;margin:30px auto 30px;color:#ffc497;text-transform: uppercase;" v-html="$t('cgtips1')"></div>
          <div class="ac" style="color:#ffc497;width:80%;margin:0 auto 40px;">{{$t('cgtips2')}}</div>
          <div class="input-div">
            <div class="span fs33 fw7">{{$t('phoneNumber')}}</div>
            <div class="input-item">
                <span>09</span>
              <input class="input" v-model="account" placeholder="">
            </div>
          </div>
          <div class="ac mt100">
            <button class="btn btn-blue" style="width:70%;" @click="goLogin">{{$t('Login')}}</button>
          </div>
          <div class="ac otp-b mt100">
            {{$t('cgtips3')}}
            <router-link class="fs33 opt-a " :to="{path:'/TC'}">{{$t('TC')}}</router-link>
            {{$t('cgtips4')}}
          </div>
        </div>
      </div>
		</div>
	</div>
</template>
<script>
import Header from '../components/headerNo'
export default {
    components:{
		Header
    },
    data() {
      return {
        list:[],
        account:'',
        password:'',

      }
    },
	created(){
	},
    methods: {
		back(){
			this.$router.go(-1);
		},

		goLogin(){
		  let that = this
		  if(that.account==''){
		  	that.$utils.alertText(that.$t('phone_error'),60)
		  	return;
		  }
      let mobile = '959'+this.account
      window.location.href = "http://ittest.gameywar.com/cg/flow?mobile="+mobile;
		},
	}
}
</script>
<style scoped>
  .drop-down-content{z-index:9;background:none;}
  .input{background:#ffc497;height:70px;border:none;border-radius: 20px;font-size:38px;font-family:MyriadProBold;padding:0 20px;width:80%;color: #280933;}
  .input-div{margin:30px 40px 10px;}
  .input-div .span{margin: 0 auto 10px;width:70%;}
  .input-item{background:#ffc497;border-radius: 20px;height:80px;line-height:80px;width:70%;margin: 0 auto;}
  .input-div div span{font-size:38px;padding-left: 30px;color: #280933;}
  .mt100{margin-top:100px;}
  .opt-a{color: #2d31fa;text-decoration: underline;}
  .btn{line-height:80px;background-color:#ffd024;width:100%;color:#280933;}
  .cg-page{background:url(../../static/images/Background.png) no-repeat 0 0 #280933;color:#fff}
  .otp-b a{color:#fff}
</style>



// WEBPACK FOOTER //
// src/page/Login2.vue